<section class="container">
  <header class="mb-2 mb-md-4 d-flex flex-column flex-md-row align-items-start justify-content-between align-items-md-center">
    <div>
      <span class="type-body-md text-secondary fw-bold w-100">
        {{ block.subtitle || ('content-block-verhalen-subtitel' | fromDictionary) }}
      </span>
      <h1 class="h2 text-primary">
        {{ block.title || ('content-block-verhalen-titel' | fromDictionary) }}
      </h1>
    </div>

    <a class="button button-link button--primary" [routerLink]="moreUrl.url" [queryParams]="moreUrl.queryParams">
      <span>{{ 'block-stories-bekijk-alle-knoptekst' | fromDictionary }}</span>
      <app-icon anchor="icon-arrow-right"></app-icon>
    </a>
  </header>

  <main *ngIf="stories?.length">
    <!--<app-slider [cursorArrow]="false" [total]="events!.length" [config]="sliderConfig">
      <div class="col-12 col-xsm-6 col-sm-6 col-md-6 col-lg-4" *ngFor="let event of events">
        <app-event-card [inverted]="true" [event]="event"></app-event-card>
      </div>
    </app-slider>-->

    <app-slider-v2>
      <swiper-slide class="swiper-slide" *ngFor="let story of stories">
        <app-story-card class="swiper-slide__card" [inverted]="true" [story]="story"></app-story-card>
      </swiper-slide>
    </app-slider-v2>
  </main>
</section>
